import { GridLayer } from 'react-leaflet'
import { observer } from 'mobx-react'

require('leaflet-bing-layer')

// Wrap the leaflet-bing-layer plugin so it works like
// a react-leaflet component
@observer class BingLayer extends GridLayer {
  componentWillMount () {
    super.componentWillMount()
    this.leafletElement = window.L.tileLayer.bing({
      ...this.props
    })
  }
}

export default BingLayer
